import { useState, useEffect } from "react";
import AddCircle from "@mui/icons-material/AddCircleRounded";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import { InputGroup, Button, Col } from "react-bootstrap";
import _ from "lodash";
import ApiAccount from "../../../core/api/api.account";
import { FormProvider, useForm, Controller } from "react-hook-form";
import DataGrid from "./DataGrid";
import { AddEditeModal } from "./AddEditeModal";
import { useLocation, useNavigate } from "react-router-dom";
import { tools } from "../../../core/utils/tools";
import GlobalFormControl from "../_Components/GlobalFormControl";

const Account = () => {
  const [listData, setListData] = useState({});
  const location = useLocation();
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(location.search);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  } = useForm({});
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  const [showModalAccount, setShowModalAccount] = useState(false);
  const [selectedAccountId, setSelectedAccountId] = useState(null);
  const pageSizeFromUrl1 = searchParams.get("pageSize");
  const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : 10;
  const pageNumberFromUrl1 = searchParams.get("pageNumber");
  const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1) ? _.toNumber(pageNumberFromUrl1) : 1;

  // let location = useLocation();
  // let background = location.state && location.state.background;

  useEffect(() => {
    (async () => {
      try {
        const data = await ApiAccount.getAllAccount({
          pageSize: getValues("pageSize"),
          pageNumber: getValues("pageNumber"),
          globalSearch: searchParams.get("globalSearch"),
        });
        setListData(data);
        setValue("totalCount", data.totalCount);
        const formInputs = [
          { name: "pageSize", type: "number" },
          { name: "globalSearch", type: "text" },
          { name: "pageNumber", type: "number" },
        ];
        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
      } finally {
      }
    })();
    return () => { };
  }, []);

  const onSubmit = async (data) => {
    const apiData = await ApiAccount.getAllAccount({
      pageSize: data.pageSize,
      pageNumber: getValues("pageNumber"),
      globalSearch: data.globalSearch,
    });
    setListData(apiData);
    setValue("totalCount", apiData.totalCount);
    tools.setPageNumber(data, searchParams, setValue);
    var queryString = tools.createQueryStringFromFromData(_.omit(data, ["totalPages", "totalCount"]));
    navigate(`/accounts?${queryString}`);
  };

  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">مدیریت حساب</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">لیست حساب های ثبت شده</span>
          </h3>
          <div className="card-toolbar">
            <Button
              onClick={() => {
                setSelectedAccountId(0);
                setShowModalAccount(true);
              }}
            >
              <AddCircle className="mr-1" />
              افزودن حساب جدید
            </Button>
          </div>
        </div>
        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          {/* search box */}
          <div className="border-top pt-3">
            <FormProvider {...methods}>
              <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
                {/* search box */}
                <InputGroup className="mb-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button variant="secondary" type="submit" disabled={isSubmitting}>
                    <SearchIcon />
                  </Button>
                </InputGroup>
                {/* table */}
                <Col xs="12" className="tb-reponsive px-0">
                  <DataGrid
                    data={listData}
                    setShowModalAccount={setShowModalAccount}
                    setSelectedAccountId={setSelectedAccountId}
                  />
                </Col>
                {showModalAccount && (
                  <AddEditeModal
                    showModalAccount={showModalAccount}
                    setShowModalAccount={setShowModalAccount}
                    selectedAccountId={selectedAccountId}
                  />
                )}
              </form>
            </FormProvider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Account;
